// This mixin contains code that is used for only electricity meters
import { _ } from "underscore";
import moment from 'moment';

import meters from "./meters";

export default {
  mixins: [meters],
  computed: {
    currentMeters() {
      // Gets the currently active meters. Use ONLY for setting default vaules.
      let currentMeters = _.sortBy(
        _.filter(this.meters, function (meter) {
          return !_.has(meter, "Removed");
        }),
        "Installed"
      ).reverse();
      return currentMeters;
    },
    currentMeter() {
      // Gets the currently active meter or last active meter. Use ONLY for setting default vaules.
      if (this.meters) {
        let currentMeters = _.filter(this.meters, function (meter) {
          return !_.has(meter, "Removed");
        });
        if (currentMeters.length === 0) {
          let removedMeters = _.filter(this.meters, function (meter) {
            return _.has(meter, "Removed");
          });
          let lastInstalledMeter = removedMeters[0];
          if (removedMeters.length > 1) {
            removedMeters.forEach((meter) => {
              lastInstalledMeter =
                lastInstalledMeter.Removed > meter.Removed
                  ? lastInstalledMeter
                  : meter;
            });
          }
          currentMeters = [lastInstalledMeter];
        }
        return currentMeters[0];
      }
    },
    currentConfig() {
      // Gets the currenly active meter config or last active config. Use ONLY for setting default vaules.
      return _.find(this.currentMeter.MeterConfigs, function (config) {
        return (
          moment(moment.utc().format("YYYY-MM-DD")).isSameOrAfter(
            config.EffectiveFrom,
            "day"
          ) &&
          (moment(moment.utc().format("YYYY-MM-DD")).isSameOrBefore(
            config.EffectiveTo,
            "day"
          ))
        );
      });
    }
  }
}